import { connect } from 'react-redux';
import { networkSelectors, currentUserSelectors, servicesSelectors } from '@lifesize/nucleus';
import AuthLayout from 'layouts/AuthLayout/AuthLayout';
import _get from 'lodash/get';

const mapStateToProps = state => ({
  cssFailure: _get(state, 'app.jwt.cssFailure') &&
    !_get(state, 'app.jwt.hasLoggedIn') &&
    !servicesSelectors.selectConnecting(state),
  isOffline: networkSelectors.isOffline(state),
  hasCheckInFailure: currentUserSelectors.isUnauthorized(state),
});

export default connect(mapStateToProps)(AuthLayout);
